// MUI v6 ListItem dropped the `button` prop that used to give list items this hover feedback.
export const contextMenuItemStyles = ({ palette, transitions }) => ({
  transition: transitions.create('background-color', {
    duration: transitions.duration.shortest,
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: palette.action.hover,
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },
});

export const disabledContextMenuItemStyles = ({ palette }) => ({
  opacity: palette.action.disabledOpacity,
  pointerEvents: 'none',
});
